import {
    GridCallbackDetails,
    GridFilterModel,
} from '@mui/x-data-grid-pro'

import {
    ExtendedGridColDef,
    FilterOperatorType,
    ExtendedGridFilterItem,
    ExtendedGridFilterModel,
} from '../SkyNetDataGrid.types'

export const getIncludeFiltersFromFilterModel = (filterModel: GridFilterModel,
    exceptFilterName?: string) => {
    const includeFilters = Object.fromEntries(filterModel?.items
        .filter((filter) => {
            return (Boolean(filter.value))
                && (filter.field !== exceptFilterName)
                && (filter.operator === FilterOperatorType.EqualsIncludeFilter)
        })
        .map((filter) => {
            return [
                filter.field,
                Array.isArray(filter.value) ? filter.value : [filter.value],
            ]
        }))

    return includeFilters
}

export const getOtherFilterForBodyFromFilterModel = (filterModel: GridFilterModel) => {
    const result = Object.fromEntries(filterModel?.items
        .filter((filter) => {
            return (Boolean(filter.value))
                && (filter.operator === FilterOperatorType.DataFilter)
        })
        .map((filter) => {
            return [
                filter.field,
                filter.value,
            ]
        }))

    return result
}

export const getVisibleAndToggableColumns = (columns: ExtendedGridColDef[]) => {
    return columns
        .filter((column) => {
            return !column.hiddenFromColumns
        })
        .map((column) => {
            return column.field
        })
}

// eslint-disable-next-line max-len
export const getHiddenPredefinedFiltersDefinitions = (columns: ExtendedGridColDef[]): ExtendedGridColDef[] => {
    return columns.filter((column) => {
        return column.hiddenFromColumns
            && column.filterOperators[0].value === FilterOperatorType.DataFilter
    })
}

export const getPredefinedDataFilter = (columns: ExtendedGridColDef[]) => {
    return getHiddenPredefinedFiltersDefinitions(columns)
        .map((column, index) => {
            return {
                field: column.field,
                operator: FilterOperatorType.DataFilter,
                id: index,
                // should be not undefined, or it will be filtered out by MUI default behaviour
                value: null,
                defaultValue: null,
            }
        })
}

export const hideHiddenColumnsForFilter = (columns: ExtendedGridColDef[]) => {
    return Object.fromEntries(getHiddenPredefinedFiltersDefinitions(columns)
        .map((filter) => {
            return [
                filter.field,
                false,
            ]
        }))
}

// if it's removeAll action reset to defaul value hidden predefined filters
export const resetFilterModelOnRemoveAll = (model: ExtendedGridFilterModel, details: GridCallbackDetails<'filter'>) => {
    if (details.reason === 'removeAllFilterItems') {
        return {
            ...model,
            items: [...model.items.map((item: ExtendedGridFilterItem) => {
                return {
                    ...item,
                    value: item.defaultValue,
                }
            })],
        }
    }
    return model
}
